import styled from "styled-components";

export const MyBookingUpCommingWidgetStyled = styled.div`
  .booking_item {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
